import { ChangeDetectionStrategy, Component } from '@angular/core';
import { ResetPasswordComponent, ResetPasswordComponentService } from '@spartacus/user/profile/components';
import { SpinnerComponent, PageSlotComponent, FormErrorsComponent } from '@spartacus/storefront';
import { ReactiveFormsModule } from '@angular/forms';
import { AsyncPipe } from '@angular/common';
import { TranslatePipe } from '@spartacus/core';

@Component({
    selector: 'sloan-reset-password',
    templateUrl: './sloan-reset-password.component.html',
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [SpinnerComponent, ReactiveFormsModule, PageSlotComponent, FormErrorsComponent, AsyncPipe, TranslatePipe]
})
export class SloanResetPasswordComponent extends ResetPasswordComponent {
  constructor(protected service: ResetPasswordComponentService) {
    super(service);
  }
}
